import { createApp } from 'vue';
import router from '@/router';
import { createPinia } from 'pinia';

import App from '@/App.vue';
import i18n from '@/i18n';
import vuetify from '@/plugins/vuetify';
import ThreeColumnLayout from '@/components/layout/ThreeColumnLayout.vue';
import NoneLayout from '@/components/layout/NoneLayout.vue';
import MessageResultLayout from '@/components/layout/MessageResultLayout.vue';

const app = createApp(App);

app.component('ThreeColumnLayout', ThreeColumnLayout);
app.component('NoneLayout', NoneLayout);
app.component('MessageResultLayout', MessageResultLayout);

app.use(vuetify);
app.use(i18n);
app.use(router);
app.use(createPinia());

app.config.errorHandler = (err, vm, info) => {
  console.error('Error:', err);
  console.error('Vue component:', vm);
  console.error('Additional info:', info);
};

app.mount('#app');
